@use "../styles.module.scss";
@use "../../../config/defaults.module.scss" as defaults;

.layoutWhite {
  @apply yst-bg-white;
  height: 100%;
  @apply yst-text-slate-600;
}

.main {
  &.white  {
    @apply yst-bg-white;
    margin: 0;
    padding: 0 0 24px;

    @media screen and (max-width: defaults.$mediumBreakpoint) {
      position: relative;
      margin: 0;
      padding: 0 0 24px;
      z-index: 0;
    }
  }
}
